import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StationService } from '../../../services/stations.service';
import { SysUsersService } from '../../../services/sys-users.service';

@Component({
  selector: 'ngx-nom-bullying',
  templateUrl: './nom-bullying.component.html',
  styleUrls: ['./nom-bullying.component.scss'],
})
export class NomBullyingComponent implements OnInit {
  stationId: string;
  stationData: object;
  active = 1;
  showStats = false;
  dataLoaded = false;
  user = { role: '' }

  constructor(
    private route: ActivatedRoute,
    private stationService: StationService,
    private userService: SysUsersService,
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
    });
  }

  ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.setUser();
  }

  async setUser () {
    const [error, response] = await this.userService.getProfileV2();
    if (error) return error;
    this.user = response.data;
  }

  setActiveTab(state: any, el: HTMLElement) {
    this.active = state;
    el.scrollIntoView();
  }
}
